import React from 'react';
import { CommonIconProps } from './Icon';

const XIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6095 2.27615C16.1301 1.75544 16.1301 0.911227 15.6095 0.39052C15.0888 -0.130173 14.2445 -0.130173 13.7239 0.39052L8 6.1144L2.27615 0.39052C1.75544 -0.130173 0.911227 -0.130173 0.39052 0.39052C-0.130173 0.911227 -0.130173 1.75544 0.39052 2.27615L6.1144 8L0.39052 13.7239C-0.130173 14.2445 -0.130173 15.0888 0.39052 15.6095C0.911227 16.1301 1.75544 16.1301 2.27615 15.6095L8 9.8856L13.7239 15.6095C14.2445 16.1301 15.0888 16.1301 15.6095 15.6095C16.1301 15.0888 16.1301 14.2445 15.6095 13.7239L9.8856 8L15.6095 2.27615Z"
      fill={color}
    />
  </>
);

XIcon.prototype.svgPropOverrides = { viewBox: '0 0 16 16' };

export default XIcon;
